import { Print } from "./Print";
import type { HeaderColRigthProps } from "./type";

export const ColRigth: React.FC<HeaderColRigthProps> = (props) => {
  if (props?.isPrintState) return <Print {...props} />;
  return null;
};
